import axios, { AxiosResponse } from 'axios'
import { appConfig } from '@/config/app.ts'
import { defaultHeaders } from '@/config/defaultHeaders.ts'
import { onFulfilledRequestInterceptor } from '@/core/services/interceptors.ts'
import baseApiService from '@/core/services/baseApiService.ts'

const axiosInstance = axios.create({
  baseURL: `${appConfig.walletApiUrl}/api/${appConfig.walletApiVersion}`,
  headers: defaultHeaders
})

axiosInstance.interceptors.request.use(onFulfilledRequestInterceptor)

export default baseApiService(
  axiosInstance,
  (response: AxiosResponse) => response?.data
)
